export default {
  title: 'PayPal (directo)',
  description:
    'Conecte su propia cuenta de PayPal Business para recibir pagos de PayPal directamente, con su propia tarifa. Cree una aplicación REST en el Panel de desarrollador de PayPal y pegue su Client ID y Secret a continuación.',
  connected_description: 'Su cuenta de PayPal está conectada. Los pagos se liquidarán directamente en ella.',
  guide: {
    title: 'Cómo obtener sus credenciales de PayPal',
    step1: 'Inicie sesión en el Panel de desarrollador de PayPal con su cuenta de PayPal Business.',
    step2: 'Abra «Apps & Credentials» y cree una aplicación (o abra la existente).',
    step3: 'Copie el Client ID y el Secret de la aplicación.',
    step4: 'Péguelos a continuación y haga clic en «Conectar PayPal».',
    environment_note:
      'Use sus credenciales Live para pagos reales: cambie el selector Sandbox/Live en la parte superior de «Apps & Credentials».',
    open_dashboard: 'Abrir el Panel de desarrollador de PayPal',
  },
  status: {
    connected: 'Conectado',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID de su aplicación REST de PayPal',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret de su aplicación REST de PayPal',
    },
  },
  buttons: {
    connect: 'Conectar PayPal',
    disconnect: 'Desconectar',
  },
  toasts: {
    connected: 'PayPal conectado correctamente',
    connect_failed: 'No se pudo conectar PayPal',
    disconnected: 'PayPal desconectado',
    disconnect_failed: 'No se pudo desconectar PayPal',
  },
};
